import { IPageTabNavLink } from "../interfaces-and-types";

export const reportsNavLinks: IPageTabNavLink[] = [
  {
    name: "Overview",
    route: "",
  },
  {
    name: "Balance",
    route: "balance",
  },
  {
    name: "PayOut Reconciliation",
    route: "reconciliation",
  },
  {
    name: "Revenue Recognition",
    route: "revenue",
  },
];

